<template>
  <div>
    <el-menu default-active="/main" class="el-menu-vertical-demo" background-color="#ffffff" text-color="#000000"
      active-text-color="#409EFF" router :collapse="iscollapse">
      <el-menu-item>
        <span slot="title"> <strong>SaaS后台管理系统</strong></span>
      </el-menu-item>
      <el-submenu index="/messageCenter1" v-if="iscz0 || iscz1">
        <template slot="title">
          <i class="el-icon-s-comment"></i>
          <span>帮助中心</span>
        </template>
        <el-menu-item :index="'/messageCenter1?type='+item.id" v-for="(item,index) of menuData" :key="index">
          <i class="el-icon-document"></i>{{item.title}}
        </el-menu-item>

      </el-submenu>


      <el-submenu index="/newslist" v-if="iscz0 || iscz1||isChecked52||isChecked75">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>产品管理</span>
        </template>
        <el-menu-item index="/wlw_newslist" v-if="iscz0">
          <i class="el-icon-document"></i>产品发布
        </el-menu-item>
        <el-menu-item index="/tyj_ptypelist" v-if="iscz1">
          <i class="el-icon-document"></i>产品类型管理
        </el-menu-item>

        <el-menu-item index="/broadcast2" v-if="isChecked52">
          <i class="el-icon-document"></i>文档管理
        </el-menu-item>

        <el-menu-item index="/cityManagerRule" v-if="iscz16 &&(isInner || is_show_citymanager)">
          <i class="el-icon-document"></i>城市经理规则标签
        </el-menu-item>

        <el-menu-item index="/tyj_ptypelist2" v-if="isChecked75">
          <i class="el-icon-document"></i>城市经理考核管理
        </el-menu-item>
      </el-submenu>
      <el-submenu index="/huojianglist" v-if="(iscz2 || iscz3||iscz9) && (type=='1' || isInner)">
        <template slot="title">
          <i class="el-icon-s-claim"></i>
          <span>团队奖励设置</span>
        </template>
        <el-menu-item index="/huojiang1" v-if="iscz2">
          <i class="el-icon-document"></i>直接团队奖励
        </el-menu-item>
        <el-menu-item index="/huojiang2" v-if="iscz3">
          <i class="el-icon-document"></i>间接团队奖励
        </el-menu-item>

        <el-menu-item index="/wlw_synthesizelist_tj" v-if="iscz9 && (type=='1' || isInner)">
          <i class="el-icon-document"></i>团队海报
        </el-menu-item>
      </el-submenu>
      <el-submenu index="/huifulist" v-if="iscz12 || iscz13 || iscz14">
        <template slot="title">
          <i class="el-icon-folder-opened"></i>
          <span>公众号管理</span>
        </template>
        <el-menu-item index="/huifu" v-if="iscz12">
          <i class="el-icon-document"></i>发信息自动回复
        </el-menu-item>
        <el-menu-item index="/gzhuifu" v-if="iscz13">
          <i class="el-icon-document"></i>关注自动回复
        </el-menu-item>

        <el-menu-item index="/caidan_new" v-if="iscz14">
          <i class="el-icon-document"></i>公众号菜单
        </el-menu-item>
      </el-submenu>
      <el-submenu index="/huojiang2" v-if="iscz4 || iscz5 || iscz6  ">
        <template slot="title">
          <i class="el-icon-folder-opened"></i>
          <span>综合管理</span>
        </template>
        <el-menu-item index="/menulist4">
          <i class="el-icon-document" v-if="iscz4"></i>订单管理
        </el-menu-item>

        <el-menu-item index="/menulist2" v-if="iscz5">
          <i class="el-icon-document"></i>经纪人管理
        </el-menu-item>
        <el-menu-item index="/menulist3" v-if="iscz6 && (isInner || is_show_withdrawal)">
          <i class="el-icon-document"></i>提现管理
        </el-menu-item>
        <el-menu-item index="/wlw_synthesizelist_other" v-if="isChecked50">
          <i class="el-icon-document"></i>收集信息管理
        </el-menu-item>
        <el-menu-item index="/wlw_synthesizelist_other_check" v-if="isChecked51">
          <i class="el-icon-document"></i>收集信息查看
        </el-menu-item>
        <el-menu-item index="/tag" v-if="isChecked50">
          <i class="el-icon-document"></i>信息标签管理
        </el-menu-item>

        <!-- <el-menu-item index="/dlchanpin" v-if="iscz15">
          <i class="el-icon-document"></i>点亮产品
        </el-menu-item>
        <el-menu-item index="/pingbicp" v-if="iscz15">
          <i class="el-icon-document"></i>屏蔽产品
        </el-menu-item> -->
        <!-- <el-menu-item index="/wlw_synthesizelist_other" v-if="isChecked50">
          <i class="el-icon-document"></i>收集信息管理
        </el-menu-item>
        <el-menu-item index="/wlw_synthesizelist_other_check" v-if="isChecked51">
          <i class="el-icon-document"></i>收集信息查看
        </el-menu-item>
        <el-menu-item index="/tag" v-if="isChecked50">
          <i class="el-icon-document"></i>标签管理
        </el-menu-item> -->

        <!-- <el-menu-item index="/tuanduijl" v-if="iscz15 && (type=='1' || isInner)">
          <i class="el-icon-document"></i>团队奖励
        </el-menu-item> -->


      </el-submenu>
      <el-submenu index="/zonghelist" v-if="iscz11 || iscz7 || iscz8 || iscz9 || iscz10 || isChecked52||isChecked54||isChecked56">
        <template slot="title">
          <i class="el-icon-reading"></i>
          <span>其他管理</span>
        </template>
        <!-- <el-menu-item index="/sendmessage" v-if="iscz11">
          <i class="el-icon-document"></i>群发公众号消息
        </el-menu-item> -->

        <el-menu-item index="/broadcast" v-if="isChecked52">
          <i class="el-icon-document"></i>消息管理
        </el-menu-item>
        <el-menu-item index="/broadcast_type" v-if="isChecked54">
          <i class="el-icon-document"></i>消息类型管理
        </el-menu-item>
        <el-menu-item index="/comment_reply" v-if="isChecked56">
          <i class="el-icon-document"></i>消息来个梗管理
        </el-menu-item>
        <el-menu-item index="/banner" v-if="isChecked66 && (isInner || is_show_banner)">
          <i class="el-icon-document"></i>轮播图管理
        </el-menu-item>
        <el-menu-item index="/wlw_synthesizelist" v-if="iscz7">
          <i class="el-icon-document"></i>单页管理
        </el-menu-item>
        <el-menu-item index="/wlw_synthesizelist_ad" v-if="iscz8">
          <i class="el-icon-document"></i>图片管理
        </el-menu-item>
        <!-- <el-menu-item index="/wlw_synthesizelist_td" v-if="iscz9 && (type=='1' || isInner)">
          <i class="el-icon-document"></i>邀请团队图片
        </el-menu-item> -->
        <el-menu-item index="/banner2" v-if="isChecked66">
          <i class="el-icon-document"></i>极速查询海报
        </el-menu-item>

        <el-menu-item index="/wlw_synthesizelist_pc" v-if="iscz9">
          <i class="el-icon-document"></i> 首页菜单管理
        </el-menu-item>
        <el-menu-item index="/huilv" v-if="iscz10">
          <i class="el-icon-setting"></i>个人所得税修改
        </el-menu-item>

      </el-submenu>

      <el-menu-item index="/renter" v-if="isChecked63 && isInner">
        <i class="el-icon-setting"></i>
        <span slot="title">租客管理</span>
      </el-menu-item>
      <el-menu-item index="/message" v-if="isChecked72">
        <i class="el-icon-chat-line-square"></i>
        <span slot="title">短信充值</span>
      </el-menu-item>
      <el-menu-item index="/bank4setting" v-if="isChecked80">
        <i class="el-icon-chat-line-square"></i>
        <span slot="title">银行四要素充值</span>
      </el-menu-item>
      <el-menu-item index="/nameIDCard" v-if="isChecked82">
        <i class="el-icon-chat-line-square"></i>
        <span slot="title">姓名身份证校验充值</span>
      </el-menu-item>
     <el-menu-item index="/company" v-if="isChecked68">
        <i class="el-icon-setting"></i>
        <span slot="title">公司信息设置</span>
      </el-menu-item>
      <el-menu-item index="/manageindex" v-if="isChecked62">
        <i class="el-icon-s-custom"></i>
        <span slot="title">管理员中心</span>
      </el-menu-item>

      <el-menu-item index="/balance" v-if="isChecked70">
        <i class="el-icon-bank-card"></i>
        <span slot="title">产品方结算</span>
      </el-menu-item>
      <!-- <el-menu-item index="/test">
        <i class="el-icon-setting"></i>
        <span slot="title">测试</span>
      </el-menu-item> -->
    </el-menu>
  </div>
</template>

<script>
  export default {
    //接收的数据
    props: ["iscollapse"],
    data() {
      return {
        //iscollapse: false,
        iscz0: 0,
        iscz1: 0,
        iscz2: 0,
        iscz3: 0,
        iscz4: 0,
        iscz5: 0,
        iscz6: 0,
        iscz7: 0,
        iscz8: 0,
        iscz9: 0,
        iscz10: 0,
        iscz11: 0,
        iscz12: 0,
        iscz13: 0,
        iscz14: 0,
        iscz15: 0,
        iscz16: 0,
        iscz17: 0,

        isChecked50:0,
        isChecked51:0,
        isChecked52:0,
        isChecked54:0,
        isChecked56:0,


        isChecked62:0,
        isChecked63:0,
        isChecked66:0,
        isChecked68:0,
        isChecked70:0,
        isChecked72:0,
        isChecked75:0,
        isChecked80:0,
        isChecked82:0,

        isInner:false,
        is_show_citymanager:false,
        is_show_withdrawal:false,
        is_show_banner:false,

        type:"",

        menuData:[]

      };
    },
    created() {

      //产品发布-查看权限</el-checkbox>
      if (localStorage.getItem("checked1") == "" || localStorage.getItem("checked1") == "False") {
        this.iscz0 = 0
      } else {
        this.iscz0 = 1
      }
      //类型管理-查看权限</el-checkbox>
      if (localStorage.getItem("checked3") == "" || localStorage.getItem("checked3") == "False") {
        this.iscz1 = 0
      } else {
        this.iscz1 = 1
      }

      //获奖规则</div>
      //下级奖励-查看权限</el-checkbox>
      if (localStorage.getItem("checked5") == "" || localStorage.getItem("checked5") == "False") {
        this.iscz2 = 0
      } else {
        this.iscz2 = 1
      }
      //下下级奖励-查看权限</el-checkbox>
      if (localStorage.getItem("checked7") == "" || localStorage.getItem("checked7") == "False") {
        this.iscz3 = 0
      } else {
        this.iscz3 = 1
      }

      //综合管理</div>
      //订单-查看权限</el-checkbox>
      if (localStorage.getItem("checked9") == "" || localStorage.getItem("checked9") == "False") {
        this.iscz4 = 0
      } else {
        this.iscz4 = 1
      }
      // 经纪人-查看权限</el-checkbox>
      if (localStorage.getItem("checked11") == "" || localStorage.getItem("checked11") == "False") {
        this.iscz5 = 0
      } else {
        this.iscz5 = 1
      }
      //提现管理-查看权限</el-checkbox>
      if (localStorage.getItem("checked13") == "" || localStorage.getItem("checked13") == "False") {
        this.iscz6 = 0
      } else {
        this.iscz6 = 1
      }

      //其他管理</div>
      //单页管理-查看权限</el-checkbox>
      if (localStorage.getItem("checked15") == "" || localStorage.getItem("checked15") == "False") {
        this.iscz7 = 0
      } else {
        this.iscz7 = 1
      }
      //图片管理-查看权限</el-checkbox>
      if (localStorage.getItem("checked17") == "" || localStorage.getItem("checked17") == "False") {
        this.iscz8 = 0
      } else {
        this.iscz8 = 1
      }

      // 首页菜单管理-查看权限</el-checkbox>
      if (localStorage.getItem("checked19") == "" || localStorage.getItem("checked19") == "False") {
        this.iscz9 = 0
      } else {
        this.iscz9 = 1
      }
      //个人所得税修改-查看权限</el-checkbox>
      if (localStorage.getItem("checked21") == "" || localStorage.getItem("checked21") == "False") {
        this.iscz10 = 0
      } else {
        this.iscz10 = 1
      }
      //轮播图管理-查看权限</el-checkbox>
      if (localStorage.getItem("checked66") == "" || localStorage.getItem("checked66") == "False") {
        this.isChecked66 = 0
      } else {
        this.isChecked66 = 1
      }

      //模板推送</div>
      //<el - checkbox v - model = "checked23" > 模板推送 - 查看权限 < /el-checkbox>
      if (localStorage.getItem("checked23") == "" || localStorage.getItem("checked23") == "False") {
        this.iscz11 = 0
      } else {
        this.iscz11 = 1
      }

      //公众号管理</div>
      //公众号自动回复-查看权限</el-checkbox>
      if (localStorage.getItem("checked27") == "" || localStorage.getItem("checked27") == "False") {
        this.iscz12 = 0
      } else {
        this.iscz12 = 1
      }
      //关注后自动回复-查看权限</el-checkbox>
      if (localStorage.getItem("checked29") == "" || localStorage.getItem("checked29") == "False") {
        this.iscz13 = 0
      } else {
        this.iscz13 = 1
      }
      //公众号菜单-查看权限</el-checkbox>*/
      if (localStorage.getItem("checked31") == "" || localStorage.getItem("checked31") == "False") {
        this.iscz14 = 0
      } else {
        this.iscz14 = 1
      }

      // 经纪人-审核操作权限  点亮产品
      if (localStorage.getItem("checked12") == "" || localStorage.getItem("checked12") == "False") {
        this.iscz15 = 0
      } else {
        this.iscz15 = 1
      }

      if (localStorage.getItem("checked46") == "" || localStorage.getItem("checked46") == "False") {
        this.iscz16 = 0
      } else {
        this.iscz16 = 1
      }

      if (localStorage.getItem("checked50") == "" || localStorage.getItem("checked50") == "False") {
        this.isChecked50 = 0
      } else {
        this.isChecked50 = 1
      }

      if (localStorage.getItem("checked51") == "" || localStorage.getItem("checked51") == "False") {
        this.isChecked51 = 0
      } else {
        this.isChecked51 = 1
      }

      if (localStorage.getItem("checked52") == "" || localStorage.getItem("checked52") == "False") {
        this.isChecked52 = 0
      } else {
        this.isChecked52 = 1
      }

      if (localStorage.getItem("checked54") == "" || localStorage.getItem("checked54") == "False") {
        this.isChecked54 = 0
      } else {
        this.isChecked54 = 1
      }

      if (localStorage.getItem("checked56") == "" || localStorage.getItem("checked56") == "False") {
        this.isChecked56 = 0
      } else {
        this.isChecked56 = 1
      }

      if (localStorage.getItem("checked62") == "" || localStorage.getItem("checked62") == "False") {
        this.isChecked62 = 0
      } else {
        this.isChecked62 = 1
      }

      if (localStorage.getItem("checked63") == "" || localStorage.getItem("checked63") == "False") {
        this.isChecked63 = 0
      } else {
        this.isChecked63 = 1
      }

      if (localStorage.getItem("checked68") == "" || localStorage.getItem("checked68") == "False") {
        this.isChecked68 = 0
      } else {
        this.isChecked68 = 1
      }

      if (localStorage.getItem("checked70") == "" || localStorage.getItem("checked70") == "False") {
        this.isChecked70 = 0
      } else {
        this.isChecked70 = 1
      }

      if (localStorage.getItem("checked72") == "" || localStorage.getItem("checked72") == "False") {
        this.isChecked72 = 0
      } else {
        this.isChecked72 = 1
      }

      if (localStorage.getItem("checked75") == "" || localStorage.getItem("checked75") == "False") {
        this.isChecked75 = 0
      } else {
        this.isChecked75 = 1
      }
      if (localStorage.getItem("checked80") == "" || localStorage.getItem("checked80") == "False") {
        this.isChecked80 = 0
      } else {
        this.isChecked80 = 1
      }
      if (localStorage.getItem("checked82") == "" || localStorage.getItem("checked82") == "False") {
        this.isChecked82 = 0
      } else {
        this.isChecked82 = 1
      }




      if (localStorage.getItem("userType") == "1") {
        this.isInner = 0
        this.pullRentData()

      } else {
        this.isInner = 1
      }

      this.sernewslist()

    },
    methods:{
      sernewslist() {
        let that = this;
        localStorage.setItem("menu_rent_id","10014")
        let data = {
          rent_id:localStorage.getItem("menu_rent_id")
        };
        this.$httpPost({
          url: "/wlw_manage/broadcast_type_select.aspx",
          data: data,
        }).then((res) => {
          that.menuData = res;

        });
      },
      pullRentData() {
        let that = this;

        let data = {
          code: localStorage.getItem("rent_id")
        };

        this.$httpPost({
          url: "/wlw_manage/renter_select_one.aspx",
          data: data,
        }).then((res) => {

          that.is_show_citymanager = res.is_show_citymanager == "True"
          that.is_show_withdrawal = res.is_show_withdrawal == "True"
          that.is_show_banner = res.is_show_banner == "True"
          //type:0,直客版，type：1，渠道版
          that.type = res.type

        });
      },
    }
  };
</script>

<style lang="less" scoped>
  .el-menu {
    border-right: 0;

    .is-active {
      // background: #054476 !important;
      color: #10bc4e !important;
    }
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/views/manage_views/menu.vue